import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import { AxiosError } from "axios";
import Button from "components/button";
import Input from "components/input";
import { LoaderContext } from "contexts/loader-context";
import useRouter from "hooks/use-router";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import formServices from "services/form-builder-services";
import ProfileService from "services/profile-services";
import { Label } from "theme/theme";
import { TextOtp } from "../text.style";

function Phone({ state, handleChange, nextStep, prevStep, setHelper, session, recaptchaRef, setError }: any) {
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(formServices.formGenerateSchema(["phoneNumber"])) })
  const { history } = useRouter()
  const { setLoad } = useContext(LoaderContext)

  async function onFormSubmit(data: any) {
    recaptchaRef.current?.reset()
    await recaptchaRef.current?.executeAsync().then(async (recaptchaToken: any) => {
      setLoad(true)
      try {
        const result = await ProfileService.otpGenerate({ phone: data.phoneNumber, recaptchaToken, session })
        if (result.status === 201) {
          setHelper({ expires: result.data?.expiresAt })
          handleChange(data)
          nextStep()
        } else if (result.status === 200) {
          history.goBack()
        }
      } catch (err) {
        const typedError = err as AxiosError
        const { code } = typedError.response?.data || {}
        setError(code)
      } finally {
        setLoad(false)
      }
    })
  }

  return (
    <div className="flex flex-col flex-1 md:pt-10">
      <form className="flex h-full justify-between flex-col gap-4 mx-7 mb-7" onSubmit={handleSubmit(onFormSubmit)} noValidate>
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">Número de celular</Label>
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder="Ingresa tu número"
              name="phoneNumber"
              defaultValue={state?.phoneNumber}
              {...register("phoneNumber")}
            />
            <ErrorMessage errors={errors} name="phoneNumber" />
          </div>
          <div className="flex-1 flex flex-col items-center justify-center gap-4 text-center mx-7">
            <TextOtp className="text-center text-xl font-bold saira">Necesitamos validar tu número de teléfono para completar el registro.</TextOtp>
            <TextOtp className="text-center text-xl font-normal saira">Te enviaremos un <b>código OTP</b> para que ingreses en la siguiente pantalla.</TextOtp>
          </div>
        </div>
        <Button>
          <p className="uppercase">PEDIR CÓDIGO OTP</p>
        </Button>
        <button type="button" className="cursor-pointer" onClick={() => {
          gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'MODIFICAR TELEFONO - Volver atras', value: '10' })
          prevStep()
        }}>
          <p
            className={`din text-center mt-3 hover:text-red-100 uppercase underline`}
            style={{ fontSize: 10 }}
          >
            VOLVER
          </p>
        </button>
      </form>
    </div>
  )
}

export default Phone;